/**
 * Entwicklungs-Login: Gegenstück zu `KSB_AUTH_DEV_BYPASS` im Backend. Schaltet MSAL
 * komplett aus und lässt lokal einen Testbenutzer wählen. Nur aktiv bei
 * `VITE_KSB_AUTH_DEV_BYPASS=true` (gehört in app/.env.development.local) – ein
 * Produktions-Build mit diesem Wert bricht ab (vite.config.ts).
 */

export const istEntwicklungsLogin = import.meta.env.VITE_KSB_AUTH_DEV_BYPASS === 'true';

export interface EntwicklungsBenutzer {
  kennung: string;
  admin: boolean;
}

/** Testbenutzer der Mock-Daten (api/src/adapters/mock/seed.ts). */
export const TESTBENUTZER: { kennung: string; beschreibung: string; admin?: boolean }[] = [
  { kennung: 'anna.admin@ksb.local', beschreibung: 'Admin (kein Teilnehmer)', admin: true },
  { kennung: 'max.muster@ksb.local', beschreibung: 'Office + Copilot, nichts gebucht' },
  { kennung: 'paul.probe@ksb.local', beschreibung: 'Office, Modul 1 gebucht' },
  { kennung: 'olaf.office@ksb.local', beschreibung: 'Office, alles gebucht' },
  { kennung: 'erika.beispiel@ksb.local', beschreibung: 'Power, Modul 1 gebucht' },
  { kennung: 'lea.lernend@ksb.local', beschreibung: 'Power + Copilot, Einladung abgelehnt' },
  { kennung: 'nina.nicht@ksb.local', beschreibung: 'Nicht auf der Teilnehmerliste' },
];

const SCHLUESSEL = 'ksb.entwicklungsBenutzer';

export function leseEntwicklungsBenutzer(): EntwicklungsBenutzer | undefined {
  try {
    const roh = localStorage.getItem(SCHLUESSEL);
    return roh ? (JSON.parse(roh) as EntwicklungsBenutzer) : undefined;
  } catch {
    return undefined;
  }
}

export function setzeEntwicklungsBenutzer(benutzer: EntwicklungsBenutzer | undefined): void {
  try {
    if (benutzer) localStorage.setItem(SCHLUESSEL, JSON.stringify(benutzer));
    else localStorage.removeItem(SCHLUESSEL);
  } catch {
    // privater Modus o. Ä. – dann gilt der Login nur bis zum Neuladen
  }
}

/** Header, mit denen das Backend im Entwicklungsmodus den Benutzer erkennt. */
export function entwicklungsHeader(): Record<string, string> {
  const b = leseEntwicklungsBenutzer();
  if (!b) return {};
  return { 'x-dev-kennung': b.kennung, ...(b.admin && { 'x-dev-rollen': 'Admin' }) };
}
